import { render, staticRenderFns } from "./IconCaretSort.vue?vue&type=template&id=4d8e7533&"
import script from "./IconCaretSort.vue?vue&type=script&lang=js&"
export * from "./IconCaretSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports